/* unplugin-vue-components disabled */import { render } from "./CodeMathRender.vue?vue&type=template&id=49fb114a&scoped=true"
import script from "./CodeMathRender.vue?vue&type=script&lang=js"
export * from "./CodeMathRender.vue?vue&type=script&lang=js"

import "./CodeMathRender.vue?vue&type=style&index=0&id=49fb114a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fb114a"]])

export default __exports__